import api from "@/api/methods";

export default {
    data() {
        return {
            construction_list: [],
            construction_info: {},
        };
    },
    computed: {
        fuze_users() {
            let arr = [];
            if (this.ruleForm && this.ruleForm.construction_unit) {
                let info = this.construction_list.find(a => a.id == this.ruleForm.construction_unit);
                if (info) {
                    arr = info.users || [];
                }
            }
            return arr;
        }
    },
    methods: {
        //获取建设单位
        async GetConstruction() {
            this.construction_list = [];
            this.construction_info = {};
            let res = await api.contract.GetConstruction();
            let list = [];
            if (res.data?.data) {
                list = res.data.data.construction || [];
                let user_info = res.data.data.user_info || {};
                let user_list = res.data.data.construction_users || [];
                list.forEach(item => {
                    item.users = user_list.filter(a => a.construction_id == item.id).map(a => {
                        return user_info[a.userid] || {};
                    });
                });
                this.construction_info = res.data.data;
            }
            this.construction_list = list;
        },
    }
};